import React from 'react';
import './styles/About.css';
import resume from '../assets/documents/(lcc)_Samuel_Gyamfi_Adabor.pdf';

const About = () => {
  const skills = [
    { name: 'HTML/CSS', level: 90 },
    { name: 'JavaScript', level: 85 },
    { name: 'React', level: 70 },
    { name: 'Node.js', level: 75 },
    { name: 'Python', level: 80 },
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I am a passionate web developer with a strong foundation in front-end and back-end technologies.
              My journey in web development started 5 years ago, and I've been in love with creating
              beautiful, functional websites ever since.
            </p>
            <p>
              I specialize in building responsive web applications using modern frameworks like React
              and have experience working with various APIs and databases. I'm constantly learning
              new technologies to stay updated with the latest trends in web development.
            </p>
            <div className="education">
              <h3>Education</h3>
              <div className="education-item">
                <h4>Bachelor of Science in Information Technology Education</h4>
                <p>University of Education, Winneba, 2017-2021</p>
              </div>
            </div>
          </div>
          <div className="skills-container">
            <h3>My Skills</h3>
            <div className="skills-list">
              {skills.map((skill, index) => (
                <div className="skill-item" key={index}>
                  <div className="skill-info">
                    <p>{skill.name}</p>
                    <p>{skill.level}%</p>
                  </div>
                  <div className="skill-bar">
                    <div 
                      className="skill-progress" 
                      style={{ width: `${skill.level}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="resume-btn">
              <a href={resume} target="_blank" rel="noopener noreferrer" className="btn primary-btn">
                Download Resume
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;